// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".support-page__banner{position:relative;display:flex;justify-content:center;align-items:center}.support-page__banner img{width:100%;-o-object-fit:contain;object-fit:contain}.support-page__banner h1{font-size:25px;position:absolute;height:50px;display:flex;justify-content:center;align-items:center;padding:0 15px;top:calc(50% - 25px);background:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
